module.exports = __webpack_public_path__ + "static/media/16.f1e2e0e0.jpg";